export default __webpack_public_path__ + "static/media/clavier.b4402830.jpg";